module.exports = __webpack_public_path__ + "img/alambre galvanizado.1474ed24.jpg";